import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GeneralUtils } from '@shared/utils';
import { Router } from "@angular/router";
import { DataService } from '@core/services';

declare function createEvent(myEvent): any;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false
})
export class FooterComponent {
  isProduction = true;
  contactClicked = false;

  constructor(private router: Router , public generalUtils: GeneralUtils, private dataService: DataService) {
    this.isProduction = environment.environment === 'Production';

    // TODO: ezeket majd szebben kellene eldönteni (environment.ts)
    // TODO: jelenleg nincs éles build (tesztről másoljuk az élesbe a felületet), emiatt van így
    const test = window.location.href.includes('testhealthinsuranceportal.union.hu');
    const prod = window.location.href.includes('egeszsegbiztositas.union.hu');

    this.isProduction = prod;
  }

  openNewPage(name: string) {
    let link;
    switch (name) {
      case 'cibHu': link = 'https://www.cib.hu/'; break;
      case 'unionContacts': link = 'https://union.hu/kapcsolat'; break;
      case 'CHANGELOG': link = './assets/changelog/changes.html'; break;
      case 'dataProtection':
        link = this.dataService.selectedLanguage === 'en' ?
          'https://smartcube.union.hu/public/api/downloadPublicDocument/1352' :
          'https://www.union.hu/adatvedelem';
        break;
      case 'complaintHandling': link = 'https://www.union.hu/panaszkezeles'; break;
      case 'openingHours': link = 'https://www.union.hu/kapcsolat#nyitvatartas'; break;
      case 'moreAboutOnlinePayment': link = 'https://smartcube.union.hu/public/api/downloadPublicDocument/2528'; break;
    }
    window.open(link, "_blank");
  }

  public showCookie(): void {
    createEvent('showCookieConsent');
  }

}
